import { useEffect, useCallback } from "react";
import { useParameter, useFavouriteProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";

export function useFavourite() {
  const title = useSlideTitle();
  const {
    state: { isFavouriteLoading },
    actions: { setParameters, setApplyFunction },
  } = useFavouriteProviderContext();

  const [frequencies, setFrequencies] = useParameter<number>("@frequencies");
  const [commodityDisplay, setCommodityDisplay] = useParameter<number>("@commodities_display");
  const [commodity, setCommodity] = useParameter<number>("@commodities");
  const [units, setUnits] = useParameter<number>("@units");

  useEffect(() => {
    setParameters(title, {
      "@frequencies": frequencies,
      "@commodities": commodity,
      "@commodities_display": commodityDisplay,
      "@units": units,
    });
  }, [title, frequencies, commodity, commodityDisplay, units, setParameters]);

  const applyParameters = useCallback(
    (parameters: Record<string, string[]>) => {
      setCommodity(parameters["@commodities"].map(Number)[0]);
      setCommodityDisplay(parameters["@commodities_display"].map(Number)[0]);
      setUnits(parameters["@units"].map(Number)[0]);
      setFrequencies(parameters["@frequencies"].map(Number)[0]);
    },
    [setFrequencies, setCommodity, setCommodityDisplay, setUnits]
  );

  useEffect(() => {
    setApplyFunction(applyParameters);
  }, [setApplyFunction, applyParameters]);

  return { isFavouriteLoading };
}
